var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-14"},[_c('PublicBanner',{attrs:{"text":"کاربرد گواهینامه معادل"}}),_c('PublicList',{attrs:{"index_items":_vm.usage,"text_icon":"mdi-check-outline"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }